import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogData,
  ConfirmationDialogResult,
} from '../global-components/confirmation-dialog/confirmation-dialog.component';


@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  constructor(protected dialog: MatDialog) { }

  public open(
    data: ConfirmationDialogData,
    config?: { width?: string; panelClass?: string | string[] },
  ): Observable<boolean | ConfirmationDialogResult> {
    const extraPanelClass = config?.panelClass
      ? (Array.isArray(config.panelClass) ? config.panelClass : [config.panelClass])
      : [];

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: config?.width || '450px',
      data: data,
      panelClass: ['modern-dialog', ...extraPanelClass],
    });

    return dialogRef.afterClosed();
  }
}
